import { ameDo} from "@/api";

export default {
    methods: {
        changeInfoToCode(returnUrl, paramsInfo){
            const params = {
                p0: 'web',
                p1: 8,
                p2: 2614,
                p3: 'api',
                t: 1,
                v: (JSON.stringify(paramsInfo))
            }
            ameDo(params)
                .then(res => {
                    returnUrl = decodeURIComponent(returnUrl)
                    returnUrl += returnUrl.indexOf('?') > 0 ? '&' : '?'
                    window.location.href = `${returnUrl}returnParams=${encodeURIComponent(res)}`
                })
                .catch(err => {
                    console.error(`兑换code失败：${err.message}`)
                })
        }
    }
}
